if($(`.product__info-wrapper`).length > 0) {
  fetch('/cart.js', { credentials: 'same-origin' })
    .then(r => r.json())
    .then(cart => {
    if (cart.items.length > 0) {
      var selectedVariant = $(`[type="radio"]:checked`).val();
      let currentVariantId = $(`#product-variant`).find(`option[data-var-handle="${selectedVariant}"]`).attr(`data-var-id`); // Current product variant ID
      let variantQty = 0;
      // debugger;
      cart.items.forEach(function (item) {
        if (item.variant_id == currentVariantId) {
          variantQty = item.quantity; // Get existing quantity
        }
      });
      if (variantQty > 0) {
        $('input[name="quantity"]').attr(`max`,`${ 5 - variantQty}`);
        if(variantQty == 5) {
          $('input[name="quantity"]').val(0);
          $(`.product-form__submit`).addClass(`disabled`);
        }
        let quantityInput = $('input[name="quantity"]');  
        if (quantityInput.attr('max') === "1") {
          quantityInput.next(`.quantity__button`).addClass("disabled")
        } else {
          quantityInput.next(`.quantity__button`).removeClass("disabled")
        }
      } else {
        $('input[name="quantity"]').val(1);
        $('input[name="quantity"]').attr(`max`,`5`);
        $('input[name="quantity"]').next(`.quantity__button`).removeClass("disabled")
        $(`.product-form__submit`).removeClass(`disabled`);
      }
    }
  });  
}

function startCartTimer() {
  let expireTime = Date.now() + 30 * 60 * 1000; // 30 minutes from now
  sessionStorage.setItem("cartExpireTime", expireTime);
}

function checkCartExpiration() {
  let expireTime = sessionStorage.getItem("cartExpireTime");
  if (expireTime && Date.now() >= expireTime) {
    fetch('/cart/clear.js', { method: 'POST', credentials: 'same-origin' }) // Clears the cart
    .then(() => {
      sessionStorage.removeItem("cartExpireTime"); // Clear session timer
      location.reload();
    });
  }
}

document.addEventListener("DOMContentLoaded", function () {
  checkCartExpiration();
  setInterval(checkCartExpiration, 60000); // Check every minute
});